/**
 * Zapisuje plik z pamieci przegladarki na dysk uzytkownika (przez tymczasowy link z atrybutem `download`).
 *
 * Osobny modul, bo to jedyne miejsce dotykajace DOM przy pobieraniu raportu: testy komponentow podstawiaja go
 * atrapa, a reszta (naglowki, bledy) zostaje czystymi funkcjami.
 */
export function zapiszBlobJakoPlik(blob: Blob, nazwaPliku: string): void {
  const adres = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = adres;
  link.download = nazwaPliku;
  link.rel = "noopener";
  link.hidden = true;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Przegladarka potrzebuje chwili na rozpoczecie pobierania, zanim adres przestanie istniec.
  setTimeout(() => URL.revokeObjectURL(adres), 10_000);
}
